// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UxYJ5{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:16px;gap:16px;grid-gap:1rem;gap:1rem;margin-top:2.5rem}@media(max-width:1023px){.UxYJ5{margin-top:1.5rem}}._10-JW{width:49%}@media(max-width:1439px){._10-JW{width:100%}}._3eDyF{margin:2rem auto}._3eDyF:hover{background-color:#fff!important}._2i113{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);margin-left:.55rem}._2i113 path[fill]{fill:#0373f9}._320Og{width:100%;aspect-ratio:36/25;border-radius:24px}@media(min-width:1024px)and (max-width:1439px){._320Og{aspect-ratio:464/243}}@media(min-width:768px)and (max-width:1023px)and (orientation:portrait){._320Og{aspect-ratio:687/440}}@media(max-width:767px){._320Og{aspect-ratio:288/490;display:block}}", ""]);
// Exports
exports.locals = {
	"root": "UxYJ5",
	"card": "_10-JW",
	"moreBtn": "_3eDyF",
	"icon": "_2i113",
	"loading": "_320Og"
};
module.exports = exports;
